export default {
  "unableToLoadStations": "No se pueden cargar las estaciones",
  "unableToLoadOutlets": "No se pueden cargar los puntos de venta",
  "unableToFetchLaunchLink": "No se puede obtener el enlace de acceso",
  "stationUpdated": "Estación actualizada",
  "stationCreated": "Estación creada",
  "unableToSaveStation": "No se puede guardar la estación",
  "createStation": "Crear estación",
  "createRoute": "Crear regla",
  "activeStations": "Estaciones activas",
  "stationsReadyToAcceptNewTickets": "Estaciones listas para recibir nuevas comandas.",
  "activeRoutes": "Reglas activas",
  "liveRoutingRulesForAllStations": "Reglas de envío activas para todas las estaciones.",
  "ticketsInQueue": "Comandas en cola",
  "comingFromLiveKDSOrders": "Procedentes de pedidos en tiempo real del KDS.",
  "stationsAtAGlance": "Resumen de estaciones",
  "quickOverviewOfYourKitchenStationFleet": "Vista rápida de las estaciones de cocina.",
  "launchLinks": "Enlaces de acceso",
  "noStationsConfigured": "No hay estaciones configuradas",
  "createYourFirstKDSStationToBeginRoutingTickets": "Crea tu primera estación KDS para empezar a enviar comandas.",
  "noOutletLinked": "Sin punto de venta vinculado",
  "active": "Activa",
  "inactive": "Inactiva",
  "launchLink": "Enlace de acceso",
  "launchLinkCopied": "Enlace de acceso copiado",
  "selectAStationToGenerateALaunchLink": "Selecciona una estación para generar un enlace de acceso.",
  "secureStationURLRotatingOTP": "URL segura de la estación y código de un solo uso renovable.",
  "stationURL": "URL de la estación",
  "launchLinkNotReady": "Enlace de acceso aún no disponible",
  "copyStationURL": "Copiar URL de la estación",
  "onetimePasscode": "Código de un solo uso",
  "expiresIn": "Caduca en",
  "qRPending": "QR pendiente",
  "scanToOpenKDSStation": "Escanea para abrir la estación KDS",
  "thisStationIsCurrentlyDisabledLaunchLinksWillStillWorkButServiceWillBeLimited": "Esta estación está desactivada. Los enlaces de acceso seguirán funcionando, pero el servicio será limitado.",
  "product": "Producto",
  "prepCategory": "Categoría de preparación",
  "productCategory": "Categoría de producto",
  "outlet": "Punto de venta",
  "outletType": "Tipo de punto de venta",
  "defaultCatchall": "Regla general por defecto",
  "bar": "Bar",
  "dining": "Restaurante",
  "proShop": "Tienda de golf",
  "halfwayHouse": "Punto de avituallamiento",
  "chooseWhatTriggersThisRoute": "Elige qué activa esta regla",
  "chooseAMatchingValue": "Elige un valor de coincidencia",
  "chooseAKDSStation": "Elige una estación KDS",
  "editRoute": "Editar regla",
  "productsMarkedAsRequiringKDSAreSentToTheFirstMatchingActiveRoute": "Los productos que requieren KDS se envían según la primera regla activa que coincida.",
  "moreSpecificRoutesWinAutomaticallyForExampleProductBeatsPrepCategoryAndPrepCategoryBeatsDefault": "Las reglas más específicas tienen prioridad: producto prevalece sobre categoría de preparación, y esta sobre la regla por defecto.",
  "whatShouldTriggerThisRoute": "¿Qué debe activar esta regla?",
  "chooseTrigger": "Elige el criterio",
  "ePOSProduct": "Producto ePOS",
  "searchForAnEPOSProduct": "Buscar un producto ePOS",
  "searching": "Buscando…",
  "searchAndSelectAProduct": "Busca y selecciona un producto.",
  "choosePrepCategory": "Elige la categoría de preparación",
  "chooseProductCategory": "Elige la categoría de producto",
  "chooseOutlet": "Elige el punto de venta",
  "unnamedOutlet": "Punto de venta sin nombre",
  "chooseOutletType": "Elige el tipo de punto de venta",
  "defaultCatchesKDSrequiredItemsThatDoNotMatchAnotherRoute": "La regla por defecto recoge los artículos que requieren KDS y no coinciden con otra regla.",
  "sendTicketsTo": "Enviar comandas a",
  "chooseKDSStation": "Elige la estación KDS",
  "routeActive": "Regla activa",
  "useThisRouteWhenItMatches": "Usar esta regla cuando coincida.",
  "cancel": "Cancelar",
  "saveRoute": "Guardar regla",
  "unableToLoadRoutes": "No se pueden cargar las reglas",
  "routeUpdated": "Regla actualizada",
  "routeCreated": "Regla creada",
  "unableToSaveRoute": "No se puede guardar la regla",
  "routeDeleted": "Regla eliminada",
  "unableToDeleteRoute": "No se puede eliminar la regla",
  "default": "Por defecto",
  "routingRules": "Reglas de envío",
  "whenThisMatchesSendTicketsThereProductsMarkedAsRequiringKDSAreSentToTheFirstMatchingActiveRoute": "Envía las comandas a la estación indicada cuando coincida el criterio. Los productos que requieren KDS usan la primera regla activa que coincida.",
  "noRoutingRulesYet": "Aún no hay reglas de envío",
  "createADefaultRouteToCatchUnmatchedKDSItems": "Crea una regla por defecto para recoger los artículos KDS sin coincidencia.",
  "createPrepCategoryRoutesSuchAsDrinksBarAndFoodKitchen": "Crea reglas por categoría de preparación, por ejemplo Bebidas → Bar y Comida → Cocina.",
  "edit": "Editar",
  "deleteRoute": "Eliminar regla",
  "thisRoutingRuleWillBeRemovedImmediately": "Esta regla de envío se eliminará de inmediato.",
  "stationNameIsRequired": "El nombre de la estación es obligatorio",
  "editKDSStation": "Editar estación KDS",
  "createKDSStation": "Crear estación KDS",
  "stationName": "Nombre de la estación",
  "mainKitchen": "Cocina principal",
  "stationActive": "Estación activa",
  "allowThisStationToReceiveRoutedKDSTickets": "Permitir que esta estación reciba comandas KDS.",
  "soundEnabled": "Sonido activado",
  "playAToneWhenNewTicketsArrive": "Emitir un sonido al recibir nuevas comandas.",
  "autobumpMinutes": "Minutos para completar automáticamente",
  "automaticallyCompleteItemsAfterThisManyMinutesUse0ToKeepOff": "Completar automáticamente los artículos tras estos minutos. Usa 0 para desactivarlo.",
  "saveStation": "Guardar estación",
  "stations": "Estaciones",
  "selectAStationToManageLaunchLinks": "Selecciona una estación para gestionar sus enlaces de acceso.",
  "createYourFirstStation": "Crea tu primera estación",
  "stationsPowerTheKDSLayoutAndLaunchLinks": "Las estaciones organizan el KDS y sus enlaces de acceso.",
  "routesDecideWhereKDSrequiredItemsGo": "Las reglas determinan el destino de los artículos que requieren KDS.",
  "disabled": "Desactivada",
  "editStation": "Editar estación",
  "stationDetails": "Detalles de la estación",
  "configurationSummaryForThisStation": "Resumen de configuración de esta estación.",
  "on": "Activado",
  "off": "Desactivado",
  "autobump": "Completar automáticamente",
  "technicalKeyKey": "Clave técnica: {key}",
  "selectAStationToViewDetails": "Selecciona una estación para ver sus detalles.",
  "done": "Completado",
  "queued": "En cola",
  "inProgress": "En preparación",
  "tapAgainToUndo": "Toca de nuevo para volver a preparar",
  "order": "Pedido",
  "tableTable": "Mesa {table}",
  "countCover": "{count} comensal",
  "countCovers": "{count} comensales",
  "completedAgeAgo": "Completado hace {age}",
  "startAll": "Preparar todo",
  "bumpAll": "Completar todo",
  "reconnectingToKitchenService": "Reconectando con el servicio de cocina…",
  "liveUpdatesDegradedUsingFallbackPolling": "Actualizaciones en tiempo real interrumpidas. Consultando periódicamente…",
  "unableToVerifyOTPCheckTheCodeOrConnectivity": "No se puede verificar el código. Comprueba el código o la conexión.",
  "unableToStartItemConnectionLost": "No se puede iniciar la preparación. Se ha perdido la conexión.",
  "unableToBumpItemConnectionLost": "No se puede completar el artículo. Se ha perdido la conexión.",
  "unableToRecallItemConnectionLost": "No se puede volver a preparar el artículo. Se ha perdido la conexión.",
  "kitchenDisplay": "Pantalla de cocina",
  "syncing": "Sincronizando…",
  "syncedSecondssAgo": "Sincronizado hace {seconds}s",
  "live": "En directo",
  "reconnecting": "Reconectando",
  "lock": "Bloquear",
  "noOrdersHereYet": "Aún no hay pedidos aquí.",
  "resolvingStation": "Buscando estación…",
  "unableToLocateStation": "No se encuentra la estación.",
  "enterOnetimeCodeFromManager": "Introduce el código de un solo uso del responsable",
  "verifyingCode": "Verificando código…",
  "terminalAccessRequired": "Se requiere acceso al terminal",
  "codeDigitDigit": "Dígito {digit} del código",
  "refreshCode": "Renovar código",
  "requestFailedPleaseTryAgain": "La solicitud ha fallado. Inténtalo de nuevo.",
  "food": "Comida",
  "drinks": "Bebidas",
  "dessert": "Postres",
  "kitchen": "Cocina",
  "other": "Otros",
  "minutesMin": "{minutes} min",
  "deleteRouteConfirm": "¿Eliminar la regla?",
  "station": "Estación KDS",
  "void": "Cancelado",
  "recalled": "Devuelto a preparación",
  "createStationHeading": "Crear estación",
  "stationNotFound": "Esta estación KDS no está disponible.",
  "routeNotFound": "Esta regla de envío ya no existe.",
  "invalidSettings": "Revisa la configuración de la estación e inténtalo de nuevo.",
  "invalidRouteType": "Elige un criterio de envío válido.",
  "itemId": "Identificador del artículo",
  "itemTag": "Etiqueta del artículo",
  "menu": "Menú"
};
